// Generated by CoffeeScript 1.8.0
(function() {

    var Modal;

    Modal = (function() {
        function Modal(content) {
            this.content = content;
            this.hideOverModals();
            this.buildModal();
            this.addEvent();
        }

        Modal.prototype.showModal = function() {
            this.overlay = document.createElement('div');
            this.overlay.className = 'overlay';
            this.overlay.style.display = 'block';
            this.overlay.classList.add('animateShowOverlay');
            this.template.style.display = "block";
            document.body.appendChild(this.overlay);
            document.body.appendChild(this.template);
            window.onresize();
            this.template.classList.add('animateShowModal');
        };

        Modal.prototype.getModalElement = function () {
            return this.template;
        }

        Modal.prototype.hideOverModals = function() {
            var modal, modals, _i, _len;
            modals = document.getElementsByClassName('modal');
            for (_i = 0, _len = modals.length; _i < _len; _i++) {
                modal = modals[_i];
                modal.style.display = 'none';
            }
        };

        Modal.prototype.buildModal = function() {
            var modalContent, modalHeader;
            this.template = document.createElement('div');
            this.template.classList.add('modal-content-checkout');
            this.template.classList.add("uc-modal");
            this.template.innerHTML = this.htmlTemplate();
            modalHeader = this.template.getElementsByClassName('modal-header')[0];
            modalHeader.appendChild(this.closeButton());
            modalContent = this.template.getElementsByClassName('modal-body')[0];
            modalContent.innerHTML = this.content;
        };

        Modal.prototype.htmlTemplate = function() {
            return '<div class="modal-dialog checkout"> <div class=" bgnoise bgnoise--default"> <div class="modal-header"> <div class="modal-logo"></div> </div> <div class="modal-body clearfix"> </div> </div> </div>';
        };

        Modal.prototype.closeButton = function() {
            this.close = document.createElement('button');
            this.close.type = 'button';
            this.close.className = 'cssc-button option-version-film-close-btn';
            this.close.setAttribute('data-dismiss', 'modal');
            this.close.innerHTML = '<i class="icon-close"></i>';
            return this.close;
        };

        Modal.prototype.addEvent = function() {
            this.close.addEventListener('click', (function(e) {
                var modalContent, overlay;
                overlay = document.getElementsByClassName('overlay');
                overlay[0].parentNode.removeChild(overlay[0]);
                modalContent = document.getElementsByClassName('uc-modal')[0];
                modalContent.parentNode.removeChild(modalContent);
            }), false);
        };

        return Modal;

    })();

    window.onresize = function(event) {
        var doc, i, len, margin, modal, modals;
        modals = document.getElementsByClassName("uc-modal");
        doc = document.documentElement;
        for (i = 0, len = modals.length; i < len; i++) {
            modal = modals[i];
            margin = (window.innerHeight - modal.clientHeight) / 2;
            if(window.innerWidth > 768){
                margin += window.pageYOffset || doc.scrollTop;
            }
            modal.style.marginTop = margin + "px";
        }
    };

    window.Modal = Modal;

}).call(this);


